import { render, staticRenderFns } from "./coachCard.vue?vue&type=template&id=722d7fd4&"
import script from "./coachCard.vue?vue&type=script&lang=js&"
export * from "./coachCard.vue?vue&type=script&lang=js&"
import style0 from "./coachCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports